import React from 'react';

const CrisisProtocol: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg mb-8">
        <p className="text-xl font-bold text-red-700 mb-4">Emergency Notice:</p>
        <p className="text-gray-800 mb-4">
          While we strive to be supportive, FeelHeard.me is not designed for crisis intervention. 
          If you are experiencing a mental health emergency, please contact emergency services 
          or crisis hotlines immediately.
        </p>
        <div className="bg-white p-4 rounded-lg space-y-3">
          <p className="font-semibold text-gray-800">Emergency Contacts:</p>
          <ul className="space-y-2">
            <li className="flex items-center">
              <span className="w-2 h-2 bg-red-400 rounded-full mr-2"></span>
              <span>National Suicide Prevention Lifeline: <strong>988</strong> or <strong>1-800-273-8255</strong></span>
            </li>
            <li className="flex items-center">
              <span className="w-2 h-2 bg-red-400 rounded-full mr-2"></span>
              <span>Crisis Text Line: Text <strong>HOME</strong> to <strong>741741</strong></span>
            </li>
            <li className="flex items-center">
              <span className="w-2 h-2 bg-red-400 rounded-full mr-2"></span>
              <span>Emergency Services: <strong>911</strong> (US) or your local emergency number</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="bg-[#C2A4D6]/10 p-6 rounded-lg mt-8">
        <h5 className="font-medium text-gray-800 mb-3">Important Limitations</h5>
        <ul className="list-disc pl-5 space-y-2">
          <li>FeelHeard.me is not a substitute for professional mental health treatment</li>
          <li>Our AI companion cannot provide medical advice or diagnoses</li>
          <li>We cannot guarantee immediate response in emergency situations</li>
          <li>Users should always prioritize professional help in crisis situations</li>
        </ul>
      </div>
    </div>
  );
};

export default CrisisProtocol;